import { Component } from '@angular/core';

import{Router, NavigationEnd, RouterEvent, ResolveStart, ResolveEnd} from '@angular/router';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { ConnectionStatus, NetworkService } from './services/network.service';
import { Globals } from './globals';
import { environment } from 'src/environments/environment';
import { ApiService } from './services/api.service';
import { Title } from '@angular/platform-browser';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})

export class AppComponent {
  
  versionString: string = this.globals.VERSION_STRING;
  isResolverLoading: boolean = false;
  pageTitleText: string = "Loading...";

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private networkService: NetworkService,
    public router: Router,
    private globals: Globals,
    private api: ApiService,
    private titleService: Title
  ) {
    this.initializeApp();

    console.log(`Running app version ${this.versionString}. Environment file = ${environment?.production ? 'PROD' : 'STAGING'}`);

    if (this.globals.IS_BUSINESS_VERSION) {
      this.pageTitleText = "Carlile webPAY";
    } else {
      this.pageTitleText = "Carlile MyConnect";
    }

    this.router.events.subscribe(event => {
      const routerEvent = event as RouterEvent;
      
      if(routerEvent instanceof NavigationEnd){
          gtag('config', 'UA-186015946-1', 
                {
                  'page_path': routerEvent.urlAfterRedirects
                }
              );
      }

      if (routerEvent instanceof ResolveStart) {
        this.isResolverLoading = true;
        this.titleService.setTitle('Loading...');
      } else if (routerEvent instanceof ResolveEnd) {
        this.isResolverLoading = false;
        this.titleService.setTitle(this.pageTitleText);
      }

    })
  } 

  initializeApp() {
    this.platform.ready().then(() => {
      if (this.platform.is('cordova') || this.platform.is('mobileweb') || this.platform.is('mobile')) {
        this.statusBar.show();
        this.splashScreen.hide();
      }

      this.networkService.onNetworkChange().subscribe((status: ConnectionStatus) => {
        if (status == ConnectionStatus.Online) {
          // this.offlineManager.checkForEvents();
        }
      });
    });
  }
}
